function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { AlertsBus } from 'modules/App';
import messages from '../../../messages';
import CountryForm from './CountryForm';
var _React_PureComponent;
class Country extends (_React_PureComponent = React.PureComponent) {
    renderInfo() {
        return /*#__PURE__*/ _jsx("p", {
            className: "text--paragraph mb-7",
            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.intros.create.provideCountry))
        });
    }
    render() {
        const { StepsElement } = this.props;
        return /*#__PURE__*/ _jsxs("section", {
            className: "section",
            children: [
                StepsElement,
                this.renderInfo(),
                /*#__PURE__*/ _jsx(AlertsBus, {
                    className: "mb-6"
                }),
                /*#__PURE__*/ _jsx(CountryForm, {
                    onSuccess: ()=>this.props.onChangeView('Information'),
                    onCancel: this.props.onClose
                })
            ]
        });
    }
}
_define_property(Country, "propTypes", {
    StepsElement: PropTypes.element,
    onChangeView: PropTypes.func,
    onClose: PropTypes.func
});
export default Country;
